import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'lathatoNyilvantartasiElem',
    pure: false
})
export class UniversalPipe implements PipeTransform {
    transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => !item.rejtett && item.felhasznaloLathatja == filter);
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/universal/universal.pipe.ts